'use strict';

/**
 * This directive exists as an alternative to ng-mouseleave,
 * as a bug exists in the header whereby the use of ng-mouseleave
 * is changing the url.
 */

module.exports = function(
) {
    return {
        link: function(scope, element, attrs) {
            element.on('mouseleave', function(event) {
                scope.$eval(attrs.mouseleave);
                return false;
            });
        }
    };
};
